import { FormattedMessage, useIntl } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { Dropdown } from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { StyledLink } from 'components/v2/Link'
import { IsActive } from 'components/Chip'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { typeMessages } from 'features/Sites/components/Type/messages'
import { SitesActions } from 'features/Sites/components/Actions'
import { canWrite, isSuperAdmin } from 'features/Users/utils'
import { ReactElement } from 'react'
import { useLogin } from 'features/Login/hooks'
import { GTSite, GTSiteUser } from 'gql/types.generated'

const getUserData = (user: GTSiteUser): string => {
  return `${user.firstName} ${user.lastName} (${user.username})`
}

interface ISitesListProps {
  sites: GTSite[]
}

export const SitesList = ({ sites = [] }: ISitesListProps): ReactElement => {
  const intl = useIntl()
  const login = useLogin()
  const showCompany = isSuperAdmin(login.accessToken.conditions)

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.SITE, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.status" defaultMessage="Status" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.type" defaultMessage="Type" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.users" defaultMessage="Users" />
            </Th>
            {showCompany && (
              <Th>
                <FormattedMessage id="dictionary.company" defaultMessage="Company" />
              </Th>
            )}
          </Tr>
        </Thead>
        <Tbody>
          {sites.map((site) => {
            return (
              <Tr key={site.id}>
                {canWrite(FEATURES.SITE, login.accessToken.policies) && (
                  <Td>
                    <SitesActions site={site} />
                  </Td>
                )}
                <Td>{site.name}</Td>
                <Td>
                  <IsActive isActive={site.isActive} />
                </Td>
                <Td>{typeMessages[site.type] ? intl.formatMessage(typeMessages[site.type]) : site.type}</Td>
                <Td>
                  {site.users.length > 1 ? (
                    <Dropdown toggle={<StyledLink>{site.users.length}</StyledLink>} noPadding>
                      <List.Container>
                        {site.users.map((user) => {
                          return <List.Item key={user.id}>{getUserData(user)}</List.Item>
                        })}
                      </List.Container>
                    </Dropdown>
                  ) : site.users.length === 1 ? (
                    getUserData(site.users[0])
                  ) : (
                    0
                  )}
                </Td>
                {showCompany && <Td>{site.company.name}</Td>}
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
